import Swal from "sweetalert2";
import Vue from "vue";
import Vuex from "vuex";
import router from "./../router/index";
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    showLoading: false,
    statHideLoading: false,
    resumeOnce: null,
    statShowFrmLogin: false,
    statFromLogin: false,
    dataFrm: {
      //login
      tea_card_id: "",
      tea_birthday: "",

      //resume_01
      list_job_id: Array(),
      tea_salary: 0.0,
      tea_regis_photo: null,

      //resume_02
      tea_sex: null,
      pre_id: null,
      tea_fname: null,
      tea_lname: null,
      tea_fname_en: null,
      tea_lname_en: null,
      tea_address: null,
      tea_province: null,
      tea_district: null,
      tea_locality: null,
      tea_post_code: null,
      tea_phone: null,
      tea_mobile: null,
      tea_blood: "1",
      tea_race: "099",
      tea_nationality: "099",
      tea_religion: "01",
      tea_tall: 0,
      tea_weight: 0,

      //resume_03
      tea_fat_name: null,
      tea_mot_name: null,
      tea_age_fat: null,
      tea_occ_fat: null,
      tea_stat_fat: null,
      tea_age_mot: null,
      tea_occ_mot: null,
      tea_stat_mot: null,
      tea_status: "S",
      tea_sum_sis_bro: null,
      tea_no_child: null,
      tea_spouse_name: null,
      tea_spouse_age: null,
      tea_spouse_occ: null,
      tea_spouse_occ_address: null,
      tea_sum_child: null,
      tea_sum_child_male: null,
      tea_sum_child_female: null,

      //resume_04
      regis_teac_edu: {
        tea_edu_year_start: Array(),
        tea_edu_year_end: Array(),
        tea_edu_school_name: Array(),
        tea_edu_major: Array(),
      },
      //resume_05
      list_hiswork: {
        his_begin: Array(5),
        his_position: Array(5),
        his_end: Array(5),
        his_office: Array(5),
        his_remark_reject: Array(5),
        his_phone: Array(5),
        his_salary: Array(5),
      },

      //resume_06
      list_Special: {
        lan_en_speak: null,
        lan_en_read: null,
        lan_en_write: null,

        lan_ch_speak: null,
        lan_ch_read: null,
        lan_ch_write: null,

        lan_jp_speak: null,
        lan_jp_read: null,
        lan_jp_write: null,

        lan_ot_name: null,
        lan_ot_speak: null,
        lan_ot_read: null,
        lan_ot_write: null,

        typing_eng: null,
        typing_th: null,
        com_skill: null,
        other: null,
      },

      //resume_07
      list_Ref: {
        tea_ref_name: Array(3),
        tea_ref_age: Array(3),
        tea_ref_job: Array(3),
        tea_ref_address: Array(3),
        tea_ref_phone: Array(3),
      },

      //resume_08
      list_Emer: {
        tea_emer_name: Array(2),
        tea_emer_address: Array(2),
        tea_emer_phone: Array(2),
      },
      //resume_09
      list_train: {
        cou_year: Array(3),
        cou_object: Array(3),
        cou_place: Array(3),
        cou_hour: Array(3),
      },
      //resume_10
      tea_remark: null,

      //resume_11
      file_people_card: "",
      file_transcrip_tree: "",
      file_transcrip_pvs: "",
      file_other: "",
      fileFromLoad: {
        tea_regis_photo: "",
        file_people_card: "",
        file_transcrip_tree: "",
        file_transcrip_pvs: "",
        file_other: "",
      },
    },

    list_PreName: Array(),
    list_Nation: Array(),
    list_Religion: Array(),
    list_Blood: Array(),
    list_Sex: Array(),
    list_Status: Array(),
    list_ParentStatus: Array(),
    list_LivingState: Array(),
    list_Province: Array(),
    list_District: Array(),
    list_Locality: Array(),
    list_Occupation: Array(),
    list_PersonalDoc: Array(),
    list_Educate_Level: Array(),
    userRegis: Object(),
    listJob: Array(),
    selJob: Array(),
    listYear: Array(),
  },
  mutations: {
    get_listJob(state) {
      window.Axios.get("job/JobList").then((param) => {
        state.listJob = param.data;
      });
    },
    set_selJob(state, selJob) {
      state.selJob = selJob;
    },
    get_PreName(state) {
      state.statHideLoading = true;
      window.Axios.get("teacher/PreName").then((param) => {
        state.list_PreName = param.data;
      });
    },
    get_Nation(state) {
      state.statHideLoading = true;
      window.Axios.get("teacher/Nation").then((param) => {
        state.list_Nation = param.data;
      });
    },
    get_Religion(state) {
      state.statHideLoading = true;
      window.Axios.get("teacher/Religion").then((param) => {
        state.list_Religion = param.data;
      });
    },
    get_Blood(state) {
      state.statHideLoading = true;
      window.Axios.get("teacher/Blood").then((param) => {
        state.list_Blood = param.data;
      });
    },
    get_Sex(state) {
      state.statHideLoading = true;
      window.Axios.get("teacher/Sex").then((param) => {
        state.list_Sex = param.data;
      });
    },
    get_Status(state) {
      state.statHideLoading = true;
      window.Axios.get("teacher/Status").then((param) => {
        state.list_Status = param.data;
      });
    },
    get_ParentStatus(state) {
      state.statHideLoading = true;
      window.Axios.get("teacher/ParentStatus").then((param) => {
        state.list_ParentStatus = param.data;
      });
    },
    get_LivingState(state) {
      state.statHideLoading = true;
      window.Axios.get("teacher/LivingState").then((param) => {
        state.list_LivingState = param.data;
      });
    },
    get_Province(state) {
      state.statHideLoading = true;
      window.Axios.get("teacher/Province").then((param) => {
        state.list_Province = param.data;
      });
    },
    get_District(state) {
      state.statHideLoading = true;
      window.Axios.get("teacher/District").then((param) => {
        state.list_District = param.data;
      });
    },
    get_Locality(state) {
      state.statHideLoading = true;
      window.Axios.get("teacher/Locality").then((param) => {
        state.list_Locality = param.data;
      });
    },
    get_Occupation(state) {
      state.statHideLoading = true;
      window.Axios.get("teacher/Occupation").then((param) => {
        state.list_Occupation = param.data;
      });
    },
    get_PersonalDoc(state) {
      state.statHideLoading = true;
      window.Axios.get("teacher/PersonalDoc").then((param) => {
        state.list_PersonalDoc = param.data;
      });
    },
  },
  actions: {
    updateData(context, formData) {
      window.Axios.post("teacher/updateData", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
        .then((param) => {
          Swal.fire(param.data.title, param.data.html, param.data.icon).then(
            (result) => {
              if (result.value) {
                router.push({ name: "Home" });
                context.state.selJob = Array();
              }
            }
          );
        })
        .catch(function() {
          console.log("FAILURE!!");
        });
    },
    get_listJob(context) {
      return context.commit("get_listJob");
    },
    set_selJob(context, selJob) {
      context.commit("set_selJob", selJob);
    },
    del_selJob(context, selJob) {
      context.state.selJob.splice(selJob, 1);
    },
    get_userRegis({ state }) {
      return window.Axios.post("teacher/chUserPass", {
        tea_card_id: state.dataFrm.tea_card_id,
        tea_birthday: state.dataFrm.tea_birthday,
      }).then((param) => {
        if (param.data.status_regis == "registered") {
          Object.assign(state.dataFrm, param.data.dataResume);
          param.data.dataJob.forEach((element) => {
            // state.selJob.push(
            state.listJob.filter((val) => {
              if (val.job_id == element.job_id) {
                state.selJob.push(val);
              }
            });
          });
          param.data.regis_teac_document.find((val) => {
            if (val.doc_id == "00") {
              state.dataFrm.fileFromLoad.tea_regis_photo = val.doc_pathfile;
            }
            if (val.doc_id == "04") {
              state.dataFrm.fileFromLoad.file_people_card = val.doc_pathfile;
            }
            if (val.doc_id == "26") {
              state.dataFrm.fileFromLoad.file_transcrip_tree = val.doc_pathfile;
            }
            if (val.doc_id == "29") {
              state.dataFrm.fileFromLoad.file_transcrip_pvs = val.doc_pathfile;
            }
            if (val.doc_id == "61") {
              state.dataFrm.fileFromLoad.file_other = val.doc_pathfile;
            }
          });
          state.list_Educate_Level.forEach((val) => {
            param.data.regis_teac_edu.find((val2) => {
              if (val2.edl_id == val.edl_id) {
                Object.assign(val, val2);
              }
            });
          });
          param.data.regis_teac_hiswork.forEach((val, index) => {
            state.dataFrm.list_hiswork.his_begin[index] = val.his_begin;
            state.dataFrm.list_hiswork.his_end[index] = val.his_end;
            state.dataFrm.list_hiswork.his_office[index] = val.his_office;
            state.dataFrm.list_hiswork.his_phone[index] = val.his_phone;
            state.dataFrm.list_hiswork.his_position[index] = val.his_position;
            state.dataFrm.list_hiswork.his_remark_reject[index] =
              val.his_remark_reject;
            state.dataFrm.list_hiswork.his_salary[index] = val.his_salary;
          });
          if (param.data.regis_teac_ability.length > 0)
            Object.assign(
              state.dataFrm.list_Special,
              param.data.regis_teac_ability[0]
            );
          param.data.regis_teac_referance.forEach((val, index) => {
            state.dataFrm.list_Ref.tea_ref_name[index] = val.ref_name;
            state.dataFrm.list_Ref.tea_ref_age[index] = val.ref_age;
            state.dataFrm.list_Ref.tea_ref_job[index] = val.ref_occ;
            state.dataFrm.list_Ref.tea_ref_address[index] = val.ref_address;
            state.dataFrm.list_Ref.tea_ref_phone[index] = val.ref_phone;
          });
          param.data.regis_teac_emer.forEach((val, index) => {
            state.dataFrm.list_Emer.tea_emer_name[index] = val.emer_name;
            state.dataFrm.list_Emer.tea_emer_address[index] = val.emer_address;
            state.dataFrm.list_Emer.tea_emer_phone[index] = val.emer_phone;
          });
          param.data.regis_teac_trainer.forEach((val, index) => {
            state.dataFrm.list_train.cou_year[index] = val.cou_year;
            state.dataFrm.list_train.cou_object[index] = val.cou_object;
            state.dataFrm.list_train.cou_place[index] = val.cou_place;
            state.dataFrm.list_train.cou_hour[index] = val.cou_hour;
          });
        }
        return param.data;
      });
    },
    get_PreName(context) {
      context.commit("get_PreName");
    },
    get_Nation(context) {
      context.commit("get_Nation");
    },
    get_Religion(context) {
      context.commit("get_Religion");
    },
    get_Blood(context) {
      context.commit("get_Blood");
    },
    get_Sex(context) {
      context.commit("get_Sex");
    },
    get_Status(context) {
      context.commit("get_Status");
    },
    get_ParentStatus(context) {
      context.commit("get_ParentStatus");
    },
    get_LivingState(context) {
      context.commit("get_LivingState");
    },
    get_Province(context) {
      context.commit("get_Province");
    },
    get_District(context) {
      context.commit("get_District");
    },
    get_Locality(context) {
      context.commit("get_Locality");
    },
    get_Occupation(context) {
      context.commit("get_Occupation");
    },
    get_PersonalDoc(context) {
      context.commit("get_PersonalDoc");
    },
    get_Educate_Level({ state }) {
      state.statHideLoading = true;
      return window.Axios.get("teacher/Educate_Level").then((param) => {
        state.list_Educate_Level = param.data;
        return param.data;
      });
    },
    list_year({ state }) {
      let dtN = new Date();
      let yearNow = dtN.getFullYear();
      let yearList = Array();
      for (let i = 0; i < 60; i++) {
        yearList.push({ yearStr: (yearNow + 543 - i).toString() });
      }
      state.listYear = yearList;
    },
  },
  getters: {
    get_LivingState(state) {
      return state.list_LivingState;
    },
    get_listJob(state) {
      return state.listJob;
    },
    get_selJob(state) {
      return state.selJob;
    },
    get_userRegis(state) {
      return state.userRegis;
    },
    get_PreName(state) {
      return state.list_PreName;
    },
    get_Nation(state) {
      return state.list_Nation;
    },
    get_Religion(state) {
      return state.list_Religion;
    },
    get_Blood(state) {
      return state.list_Blood;
    },
    get_Sex(state) {
      return state.list_Sex;
    },
    get_Status(state) {
      return state.list_Status;
    },
    get_ParentStatus(state) {
      return state.list_ParentStatus;
    },
    get_Province(state) {
      return state.list_Province;
    },
    get_District: (state) => (data) => {
      let dat =
        state.list_District.filter(
          (val) => val.pro_id == data.pro_id || null
        ) || Array();
      return dat;
    },
    get_Locality: (state) => (data) => {
      let dat =
        state.list_Locality.filter(
          (val) =>
            ((val.pro_id == data.pro_id || null) &&
              val.dis_id == data.dis_id) ||
            null
        ) || Array();
      return dat;
    },
    get_Occupation(state) {
      return state.list_Occupation;
    },
    get_PersonalDoc(state) {
      return state.list_PersonalDoc;
    },
    get_ListYear(state) {
      return state.listYear;
    },
    get_DataFrm(state) {
      return state.dataFrm;
    },
    get_Educate_Level(state) {
      return state.list_Educate_Level;
    },
  },
});
